const ManuallyInputtedTransactionRefStatus = require('@/lib/Payments/ManuallyInputtedTransactionRefStatus');
const TransactionRefState = require('@/libraries/DigiTickets/Payment/TransactionRefState');

const transactionRefStateCollection = {

    /**
     * @type {TransactionRefState[]}
     */
    transactionRefStates: [],

    /**
     * Add a TransactionRefState object to or replace an existing TransactionRefState in the collection.
     *
     * @param {TransactionRefState} state
     */
    setState: (state) => {
        if (!(state instanceof TransactionRefState)) {
            throw new Error('state must be an instance of TransactionRefState');
        }

        const index = transactionRefStateCollection.transactionRefStates.findIndex(
            (obj) => obj.paymentMethod.ref === state.paymentMethod.ref
        );

        if (index === -1) {
            transactionRefStateCollection.transactionRefStates.push(state);
        } else {
            transactionRefStateCollection.transactionRefStates[index] = state;
        }
    },

    clearState: (paymentMethod) => {
        transactionRefStateCollection.setState(
            new TransactionRefState(
                paymentMethod,
                null,
                // A state with no transactionRef is invalid if the transactionRef is 'required', but is valid
                // if the transactionRef is either 'optional' or 'unsupported'.
                !(paymentMethod.manuallyInputtedTransactionRefStatus === ManuallyInputtedTransactionRefStatus.REQUIRED)
            )
        );
    },

    /**
     * Fetch an item from the collection.
     *
     * @param {string} paymentMethodRef
     *
     * @returns {TransactionRefState|undefined}
     */
    getState: (paymentMethodRef) => {
        return transactionRefStateCollection.transactionRefStates.find(
            (obj) => obj.paymentMethod.ref === paymentMethodRef
        );
    },

    /**
     * Is the TransactionRefState valid?
     *
     * @param {string} paymentMethodRef
     *
     * @returns {boolean}
     */
    isTransactionRefValid: (paymentMethodRef) => {
        return transactionRefStateCollection.transactionRefStates.filter(
            (obj) => obj.paymentMethod.ref === paymentMethodRef && obj.transactionRefIsValid
        ).length > 0;
    },

    /**
     * Return a transactionRef if it is valid else return null.
     *
     * @param paymentMethodRef
     *
     * @returns {string|null}
     */
    getValidTransactionRef: (paymentMethodRef) => {
        let state = transactionRefStateCollection.transactionRefStates.find(
            (obj) => obj.paymentMethod.ref === paymentMethodRef && obj.transactionRefIsValid
        );

        return state ? state.transactionRef : null;
    },
};

module.exports = transactionRefStateCollection;
